import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { RemoteFetchManagerBasedOnRole } from "../../../data/usecases/user-management/remote-fetch-manager-using-role";
import Endpoints from "../../../domain/endpoints";
import { ManagerData } from "../../../domain/models/user-management/manager-date";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchManagerBasedOnUserRoleInterface {
  managerData: ManagerData[];
  fetchManagerBasedOnUserRole: Function;
  fetchManagerStatus: FetchState;
}

const initialStates = {
  managerData: [],
  fetchManagerStatus: FetchState.DEFAULT,
};
const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchManagerBasedOnUserRoleSlice: StateCreator<
  FetchManagerBasedOnUserRoleInterface
> = (set) => ({
  ...initialStates,
  fetchManagerBasedOnUserRole: async (payload: any) => {
    set(() => ({
      fetchManagerStatus: FetchState.LOADING,
    }));
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteFetchManagerBasedOnRole = new RemoteFetchManagerBasedOnRole(
      `${BASE_URL}${Endpoints.ROLE_CHILDREN}`,
      axiosHttpClient
    );
    let result = await remoteFetchManagerBasedOnRole.fetch(payload);

    if (result) {
      set(() => ({ managerData: result.users }));
      set(() => ({
        fetchManagerStatus: FetchState.SUCCESS,
      }));
    }
  },
});
